import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Heading from 'shopper/components/Heading';
import Tag from 'shopper/components/Tag/V2';

import { toStoreCouponsLink } from 'lib/links';
import { trackEvent } from 'lib/posthog';

const MONTHS_PT = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

const MAX_STORES = 6;

const BestCoupons = forwardRef(({ stores = [] }, ref) => {
  if (stores.length === 0) return null;

  const now = new Date();
  const month = MONTHS_PT[now.getMonth()];
  const year = now.getFullYear();

  return (
    <div ref={ref}>
      <Heading as="h2" size="size6">
        Melhores cupons de {month} {year}
      </Heading>
      <div className="mt-4 flex flex-wrap gap-2">
        {stores.slice(0, MAX_STORES).map(({ storeName, storeSlug }) => (
          <NextLink
            key={storeSlug}
            href={toStoreCouponsLink(storeSlug)}
            prefetch={false}
            passHref
          >
            <Tag
              as="a"
              className="text-sm"
              size="size3"
              clickable
              onClick={() =>
                trackEvent('click sidebar store', {
                  source_type: 'navigation',
                  source_value: 'best_coupons',
                  option: storeSlug,
                })
              }
            >
              {storeName}
            </Tag>
          </NextLink>
        ))}
      </div>
      <hr className="my-6 border-neutral-high-300 dark:border-neutral-low-200" />
    </div>
  );
});

BestCoupons.displayName = 'BestCoupons';

BestCoupons.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeName: PropTypes.string.isRequired,
      storeSlug: PropTypes.string.isRequired,
    })
  ),
};

export default BestCoupons;
